import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Box,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Loader from "../../components/Loader";
import { makeStyles } from "@material-ui/core/styles";
import { getApi } from "../../services/api";
import * as moment from "moment";
import axios from "axios";
import { DATE_FORMATS } from "../../configs/constant";
import { USERS, GET_USER_DAY_STATUS } from "../../configs/urls";
import { KeyboardDatePicker } from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  whiteBg: {
    width: "80%",
    margin: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  label: {
    fontSize: 15,
    fontWeight: "normal",
    color: "#444",
  },
  upperTableWidth: {
    width: "124px",
  },
  value: {
    marginLeft: 7,
    textTransform: "capitalize",
    color: "#000",
    fontSize: 14,
  },
}));

export default function WorkLog() {
  const classes = useStyles();
  const [isRequesting, setIsRequestig] = useState(false);
  const [users, setUsers] = useState([]);
  const [dayStatus, setDayStatus] = useState([]);
  const [params, setParams] = useState({ role: "all", active: 1 });
  const [dayStatusParams, setDayStatusParams] = useState({
    user_id: JSON.parse(localStorage.user).id,
    date: moment().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    getAllData();
  }, []); //eslint-disable-line

  useEffect(() => {
    getApi(GET_USER_DAY_STATUS, dayStatusParams).then((res) => {
      setDayStatus(res.data);
    });
  }, [dayStatusParams]); //eslint-disable-line

  const getAllData = () => {
    setIsRequestig(true);

    const users = getApi(USERS, params);
    const dayStatus = getApi(GET_USER_DAY_STATUS, dayStatusParams);
    axios
      .all([users, dayStatus])
      .then((res) => {
        if (res[0] && res[0].data) {
          setUsers(res[0].data);
        }

        if (res[1] && res[1].data) {
          setDayStatus(res[1].data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const getLogType = (log) => {
    switch (log.status) {
      case "start_shift":
        return "Shift started at:";
      case "end_shift":
        return "Shift ended at:";
      case "start_break":
        return "Break started at:";
      case "end_break":
        return "Break ended at:";
      default:
        return "log:";
    }
  };

  const handleDateChange = (date) => {
    setDayStatusParams({
      ...dayStatusParams,
      date: moment(date).format("YYYY-MM-DD"),
    });
  };

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          style={{
            marginRight: 20,
            borderBottomWidth: 1,
            borderBottomColor: "#000",
          }}
        >
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="h6" className={classes.title}>
              WorkLog
            </Typography>
            <form className={classes.container} noValidate>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/DD/YYYY"
                margin="normal"
                id="date-picker-inline"
                label="Date picker inline"
                value={dayStatusParams.date}
                onChange={handleDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </form>
          </Grid>
        </GridItem>
      </GridContainer>
      {dayStatus.status_list && dayStatus.status_list.length > 0 ? (
        <GridContainer>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  className={`${classes.label} ${classes.upperTableWidth}`}
                >
                  Day started At:
                </TableCell>
                <TableCell className={classes.value}>
                  {moment(dayStatus.start_shift_time).format(
                    DATE_FORMATS.DATE_TIME_FORMAT
                  ) || "--"}
                </TableCell>
              </TableRow>
              {dayStatus.start_break_time && (
                <TableRow>
                  <TableCell
                    className={`${classes.label} ${classes.upperTableWidth}`}
                  >
                    Started Break At:
                  </TableCell>
                  <TableCell className={classes.value}>
                    {moment(dayStatus.start_break_time).format(
                      DATE_FORMATS.DATE_TIME_FORMAT
                    ) || "--"}
                  </TableCell>
                </TableRow>
              )}

              <TableRow style={{ marginTop: 50, paddingTop: 50 }}>
                <TableCell
                  className={`${classes.label} ${classes.upperTableWidth}`}
                  style={{ fontWeight: "bold" }}
                >
                  Status List:
                </TableCell>
                <TableCell
                  className={`${classes.value} ${classes.upperTableWidth}`}
                ></TableCell>
              </TableRow>

              {dayStatus.status_list &&
                dayStatus.status_list.map((log) => (
                  <TableRow>
                    <TableCell
                      className={`${classes.label} ${classes.upperTableWidth}`}
                    >
                      {getLogType(log)}
                    </TableCell>
                    <TableCell className={classes.value}>
                      {moment(log.date_time).format(
                        DATE_FORMATS.DATE_TIME_FORMAT
                      ) || "--"}{" "}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </GridContainer>
      ) : (
        <Box
          fontSize="h6.fontSize"
          m={1}
          p={{ xs: 2, sm: 2, md: 2 }}
          style={{ textAlign: "center" }}
        >
          No Logs Found
        </Box>
      )}
    </div>
  );
}
